module.exports = __webpack_public_path__ + "img/cardFire.9984ca61.png";